import React from 'react'
import Layout from '../components/layout'
import { StaticImage } from "gatsby-plugin-image"
import FloatingTranslator from "../components/FloatingTranslator";

const Success = () => {
    return (
        <Layout>
            <section className='py-28 lg:py-44 lg:max-w-[1440px] mx-auto px-6 text-[#4F4F4F]'>
                <div className='grid gap-3 lg:grid-cols-2 lg:ml-[8%] mx-[5%] lg:mx-0'>
                    <div className='my-auto'>
                        <h2 className='text-4xl lg:text-7xl font-bold'>Thank you for your response!</h2>
                        <p className='mt-11 text-lg lg:text-2xl font-medium'>Our sales team would reach out to you shortly.</p>
                    </div>
                    <StaticImage
                        src="../images/success.png"
                        alt='thank you'
                        placeholder="blurred"
                        quality="100"
                    />
                </div>
                 <FloatingTranslator />
            </section>
        </Layout>
    )
}

export default Success